import styled from 'styled-components';
import { XIColors } from '@inmoment/the-kitchen';
import { TextSizes } from '@inmoment/the-kitchen';
const { grey } = XIColors;

interface TextWrapperProps {
  width: number;
  size: TextSizes;
}
interface TableRowWrapperStyles {
  background: string;
}
export const TableRowWrapper = styled.div`
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  background: ${(props: TableRowWrapperStyles) => props.background};
`;

export const ItemWrapper = styled.div`
  box-sizing: border-box;
  flex: 1;
  display: flex;
  min-width: ${(props: TextWrapperProps) => props.width}px;
  text-overflow: ellipsis;
`;

export const FirstTextWrapper = styled.div`
  border: 1px solid ${grey.light[80]};
  background: ${grey.light[95]};
  border-radius: 6px;
  padding: 3px;
  height: inherit;
  width: max-content;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FirstItemWrapper = styled.div`
  box-sizing: border-box;
  min-width: ${(props: TextWrapperProps) => props.width}px;
  padding: 12px;
  word-break: break-word;
`;
